import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postStudioAvalaibility = async ({ payload }) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: `/studio/availability`, data: payload });

  return data;
};

export default postStudioAvalaibility;
